module.exports = __webpack_public_path__ + "static/media/ucdlogo.26927302.png";